import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex justify-between gap-2 flex-wrap" };
const _hoisted_2 = { class: "flex justify-start gap-2 flex-wrap" };
const _hoisted_3 = { class: "flex justify-end items-center gap-3" };
import { ref, computed, onMounted } from "vue";
import { useDebounceFn } from "@vueuse/core";
import { useStore } from "vuex";
import SettingsPopover from "@/components/overview/logged-time/SettingsPopover.vue";
import WeeklyDateRangeSelector from "@/components/ui/date-range/overview/WeeklyDateRangeSelector.vue";
import DailyDateRangeSelector from "@/components/ui/date-range/overview/DailyDateRangeSelector.vue";
import { $tf } from "@/plugins/i18n";
var INTERVAL;
(function (INTERVAL) {
    INTERVAL["DAILY"] = "daily";
    INTERVAL["WEEKLY"] = "weekly";
})(INTERVAL || (INTERVAL = {}));
export default /*@__PURE__*/ _defineComponent({
    __name: 'OverviewTreeTableHeader',
    props: {
        overviewItems: {},
        initialSelectedDay: {},
        selectedDay: {},
        dayRangeLength: {},
        initialSelectedWeek: {},
        selectedWeek: {},
        weekRangeLength: {},
        filters: {},
        selectedInterval: {}
    },
    emits: [
        "update:selectedInterval",
        "update:selectedDay",
        "update:selectedWeek",
        "update:filters",
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const store = useStore();
        const debouncedSearch = useDebounceFn((value) => {
            const updatedFilters = { ...props.filters, query: value.target.value };
            emit("update:filters", updatedFilters);
        }, 500);
        const loggedTimeFilterOptions = computed(() => {
            return [
                // leszűröd azokat az embereket akiknek az adott periódusban a worktimejukhoz képest magasabb a logolásuk (embernél logged time piros felfele mutató ikonnal)
                {
                    label: $tf("timeManagementOverview.filterByLoggedTime.overloggedTimeLogging|Túl sok időt rögzítő emberek"),
                    value: "OVERLOGGED_TIME_LOGGING",
                },
                //  leszűröd azokat az embereket akiknek az adott periódusban a worktimejukhoz képest alacsonyabb a logolásuk (embernél logged time piros)
                {
                    label: $tf("timeManagementOverview.filterByLoggedTime.insufficientTimeLogging|Nem elég időt rögzítő emberek"),
                    value: "INSUFFICIENT_TIME_LOGGING",
                },
                //  leszűröd azokat az embereket akiknek az adott periódusban az allokációjukhoz képest magasabb a logolásuk egy projekten (projektnél logged time piros felfele mutató ikonnal)
                {
                    label: $tf("timeManagementOverview.filterByLoggedTime.overloggedProject|Túlterhelt projekttel rendelkező emberek"),
                    value: "OVERLOGGED_PROJECT",
                },
                //  leszűröd azokat az embereket akiknek az adott periódusban az allokációjukhoz képest alacsonyabb a logolásuk egy projekten (projektnél logged time piros)
                {
                    label: $tf("timeManagementOverview.filterByLoggedTime.underloggedProject| Aluljelentett projekttel rendelkező személyek"),
                    value: "UNDERLOGGED_PROJECT",
                },
            ];
        });
        const teams = computed(() => store.getters["census_team/teams"]);
        const teamFilterOptions = computed(() => {
            return teams.value.map((t) => ({
                label: t.name,
                value: t.id,
            }));
        });
        const projectFilterOptions = computed(() => {
            const projects = [];
            const seenIds = new Set();
            props.overviewItems.forEach((node) => {
                node.children.forEach((child) => {
                    if (child.projectData !== null &&
                        child.projectData?.id &&
                        !seenIds.has(child.projectData.id)) {
                        projects.push(child.projectData);
                        seenIds.add(child.projectData.id);
                    }
                });
            });
            return projects.map((p) => ({
                label: p?.name,
                value: p.id,
            }));
        });
        onMounted(() => {
            store.dispatch("census_team/fetchTeams");
        });
        // Popover
        const settingsPopover = ref(null);
        const openSettingsPopover = ($event) => {
            settingsPopover.value.popoverRef.toggle($event);
        };
        // Selected interval
        const updateSelectedInterval = (interval) => {
            emit("update:selectedInterval", interval);
        };
        return (_ctx, _cache) => {
            const _component_InputIcon = _resolveComponent("InputIcon");
            const _component_InputText = _resolveComponent("InputText");
            const _component_IconField = _resolveComponent("IconField");
            const _component_MultiSelect = _resolveComponent("MultiSelect");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_IconField, { class: "!shadow-none" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_InputIcon, null, {
                                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                            _createElementVNode("i", { class: "pi pi-search text-surface-400 !text-[0.765rem]" }, null, -1)
                                        ]))]),
                                    _: 1
                                }),
                                _createVNode(_component_InputText, {
                                    class: "border !border-surface-100 !bg-surface-0 !py-1.5 !pl-8 !shadow-none",
                                    placeholder: _unref($tf)('timeManagementOverview.filterByComment.placeholder|Szűrés komment alapján'),
                                    onInput: _unref(debouncedSearch)
                                }, null, 8, ["placeholder", "onInput"])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_MultiSelect, {
                            "model-value": __props.filters.loggedTime,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] =
                                (value) => emit('update:filters', { ...__props.filters, loggedTime: value })),
                            options: loggedTimeFilterOptions.value,
                            "option-label": "label",
                            "option-value": "value",
                            placeholder: _unref($tf)('timeManagementOverview.filterByLoggedTime.placeholder|Rögzített idő'),
                            "max-selected-labels": 1,
                            "dropdown-icon": "pi pi-plus-circle",
                            filter: "",
                            "filter-placeholder": _unref($tf)('timeManagementOverview.filterByLoggedTime.filterPlaceholder|Szűrés idő szerint')
                        }, {
                            option: _withCtx(({ option }) => [
                                _createTextVNode(_toDisplayString(option.label), 1)
                            ]),
                            _: 1
                        }, 8, ["model-value", "options", "placeholder", "filter-placeholder"]),
                        _createVNode(_component_MultiSelect, {
                            "model-value": __props.filters.team,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] =
                                (value) => emit('update:filters', { ...__props.filters, team: value })),
                            options: teamFilterOptions.value,
                            "option-label": "label",
                            "option-value": "value",
                            placeholder: _unref($tf)('timeManagementOverview.filterByTeam.placeholder|Csapat'),
                            "max-selected-labels": 2,
                            "dropdown-icon": "pi pi-plus-circle",
                            filter: "",
                            "filter-placeholder": _unref($tf)('timeManagementOverview.filterByTeam.filterPlaceholder|Szűrés csapat alapján')
                        }, {
                            option: _withCtx(({ option }) => [
                                _createTextVNode(_toDisplayString(_unref($tf)(option.label)), 1)
                            ]),
                            _: 1
                        }, 8, ["model-value", "options", "placeholder", "filter-placeholder"]),
                        _createVNode(_component_MultiSelect, {
                            "model-value": __props.filters.projects,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] =
                                (value) => emit('update:filters', { ...__props.filters, projects: value })),
                            options: projectFilterOptions.value,
                            "option-label": "label",
                            "option-value": "value",
                            placeholder: _unref($tf)('timeManagementOverview.filterByProjects.placeholder|Projektek'),
                            "max-selected-labels": 2,
                            "dropdown-icon": "pi pi-plus-circle",
                            filter: "",
                            "filter-placeholder": _unref($tf)('timeManagementOverview.filterByProjects.filterPlaceholder|Szűrés projektek szerint')
                        }, {
                            option: _withCtx(({ option }) => [
                                _createTextVNode(_toDisplayString(_unref($tf)(option.label)), 1)
                            ]),
                            _: 1
                        }, 8, ["model-value", "options", "placeholder", "filter-placeholder"])
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _withDirectives(_createVNode(DailyDateRangeSelector, {
                            "initial-selected-day": __props.initialSelectedDay,
                            "selected-day": __props.selectedDay,
                            "day-range-length": __props.dayRangeLength,
                            "onUpdate:selectedDay": _cache[3] || (_cache[3] = (value) => emit('update:selectedDay', value))
                        }, null, 8, ["initial-selected-day", "selected-day", "day-range-length"]), [
                            [_vShow, __props.selectedInterval === INTERVAL.DAILY]
                        ]),
                        _withDirectives(_createVNode(WeeklyDateRangeSelector, {
                            "initial-selected-week": __props.initialSelectedWeek,
                            "selected-week": __props.selectedWeek,
                            "week-range-length": __props.weekRangeLength,
                            "onUpdate:selectedWeek": _cache[4] || (_cache[4] = (value) => emit('update:selectedWeek', value))
                        }, null, 8, ["initial-selected-week", "selected-week", "week-range-length"]), [
                            [_vShow, __props.selectedInterval === INTERVAL.WEEKLY]
                        ]),
                        _createElementVNode("i", {
                            class: _normalizeClass(["fa-solid fa-sliders text-surface-500 text-lg cursor-pointer hover:!text-primary-500", {
                                    '!text-primary-500': settingsPopover.value?.popoverRef?.visible,
                                }]),
                            onClick: _cache[5] || (_cache[5] = ($event) => (openSettingsPopover($event))),
                            onKeyup: _cache[6] || (_cache[6] = _withKeys(($event) => (openSettingsPopover($event)), ["enter"])),
                            tabindex: "0"
                        }, null, 34)
                    ])
                ]),
                _createVNode(SettingsPopover, {
                    ref_key: "settingsPopover",
                    ref: settingsPopover,
                    "selected-interval": __props.selectedInterval,
                    "onUpdate:selectedInterval": updateSelectedInterval
                }, null, 8, ["selected-interval"])
            ]));
        };
    }
});
